/* ============================================
   COUNTDOWN TIMER — incolla in assets/countdown-timer.js
   ============================================ */

(function () {
  const STORAGE_KEY  = 'countdown_end';
  const RESET_MS     = 12 * 60 * 60 * 1000; // 12 ore in ms

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getEndTime() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const end = parseInt(stored, 10);
        if (end > Date.now()) return end;
      }
    } catch (_) {}

    // Crea nuovo end time
    const end = Date.now() + RESET_MS;
    try { localStorage.setItem(STORAGE_KEY, end); } catch (_) {}
    return end;
  }

  function init() {
    const hoursEl   = document.getElementById('countdown-hours');
    const minutesEl = document.getElementById('countdown-minutes');
    const secondsEl = document.getElementById('countdown-seconds');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    const endTime = getEndTime();

    function tick() {
      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        // Reset
        try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
        location.reload();
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const hours        = Math.floor(totalSeconds / 3600);
      const minutes      = Math.floor((totalSeconds % 3600) / 60);
      const seconds      = totalSeconds % 60;

      hoursEl.textContent   = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
